import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Dropzone from 'react-dropzone'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import ReactTooltip from 'react-tooltip'

import UserAvatar from '../components/mini/UserAvatar'
import UserName from '../components/mini/UserName'

import {
  changePasswordReset,
  changePassword,
  updateAccount
} from '../actions/account'
import {
  email,
  password,
  save,
  cancel,
  photo,
  clickToShowPassword,
  clickToHidePassword
} from '../utils/messages'
import { validatePassword } from '../utils/validation'

class Account extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentPassword: '',
      newPassword: '',
      files: [],
      showPasswords: false
    }

    this.onImageSelectBound = this.onImageSelect.bind(this)
    this.uploadPhotoBound = this.uploadPhoto.bind(this)
    this.handleCurrentPasswordChangeBound =
      this.handleCurrentPasswordChange.bind(this)
    this.handleNewPasswordChangeBound = this.handleNewPasswordChange.bind(this)
    this.changePasswordBound = this.changePassword.bind(this)
    this.resetFilesBound = this.resetFiles.bind(this)
    this.toggleShowPasswordsBound = this.toggleShowPasswords.bind(this)
  }

  componentDidMount() {
    this.props.dispatch(changePasswordReset())
    window.scrollTo(0, 0)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.passwordChangeSuccess || nextProps.passwordChangeFailure) {
      document.querySelectorAll('.password').forEach(el => {
        el.value = ''
      })

      this.setState({
        currentPassword: '',
        newPassword: '',
        showPasswords: false
      })
    }
  }

  getStatusTextClass() {
    const { passwordChangeSuccess, passwordChangeFailure } = this.props
    let klass = ['status-text']
    if (passwordChangeSuccess) {
      klass.push('success')
    } else if (passwordChangeFailure) {
      klass.push('failure')
    }
    return klass.join(' ')
  }

  render() {
    const {
      user,
      passwordChangeSuccess,
      passwordChangeFailure,
      isChangingPassword
    } = this.props
    const { showPasswords } = this.state

    const statusTextClass = this.getStatusTextClass()

    return (
      <div className="account">
        <form role="form" id="frmChangePassword">
          {user && (
            <div className="user-details">
              <UserAvatar photoUrl={user.photo.url} name={user.name} />
              <UserName
                activeCertifications={user.active_certifications}
                userId={`account-${user.id}`}
                rebuild
              >
                <h3>{user.name}</h3>
              </UserName>
            </div>
          )}
          {user && (
            <div className="form-group">
              <div className="label-wrapper">
                <label>{email}</label>
              </div>
              <div className="email">{user.email}</div>
            </div>
          )}

          <div className="failure-text">
            {passwordChangeFailure && (
              <div className={statusTextClass}>
                <FormattedMessage
                  id={'Account.CurrentPasswordIsIncorrect'}
                  defaultMessage={'Current password is incorrect.'}
                />
              </div>
            )}
          </div>

          <div className="form-group">
            <ReactTooltip
              id="currentPasswordTooltip"
              getContent={[
                () => {
                  return !showPasswords
                    ? clickToShowPassword
                    : clickToHidePassword
                }
              ]}
            />
            <ReactTooltip
              id="newPasswordTooltip"
              getContent={[
                () => {
                  return !showPasswords
                    ? clickToShowPassword
                    : clickToHidePassword
                }
              ]}
            />

            <div className="label-wrapper">
              <label htmlFor="currentPassword">Current {password}</label>
            </div>
            <input
              id="currentPassword"
              type={showPasswords ? 'text' : 'password'}
              className="password"
              placeholder="Current Password"
              onChange={this.handleCurrentPasswordChangeBound}
            />

            {!showPasswords ? (
              <div
                data-for="currentPasswordTooltip"
                data-tip={clickToShowPassword}
              >
                <div
                  className="hideshow hidden-icon"
                  onClick={this.toggleShowPasswordsBound}
                />
              </div>
            ) : (
              <div
                data-for="currentPasswordTooltip"
                data-tip={clickToHidePassword}
              >
                <div
                  className="hideshow shown-icon"
                  onClick={this.toggleShowPasswordsBound}
                />
              </div>
            )}
          </div>

          <div className="form-group">
            <div className="label-wrapper">
              <label htmlFor="newPassword">New {password}</label>
            </div>
            <input
              id="newPassword"
              type={showPasswords ? 'text' : 'password'}
              className="password"
              placeholder="New Password"
              onChange={this.handleNewPasswordChangeBound}
            />
            {!showPasswords ? (
              <div data-for="newPasswordTooltip" data-tip={clickToShowPassword}>
                <div
                  className="hideshow hidden-icon"
                  onClick={this.toggleShowPasswordsBound}
                />
              </div>
            ) : (
              <div data-for="newPasswordTooltip" data-tip={clickToHidePassword}>
                <div
                  className="hideshow shown-icon"
                  onClick={this.toggleShowPasswordsBound}
                />
              </div>
            )}
            <div className="password-reqs">
              <FormattedMessage
                id={'Account.Minimum8Characters'}
                defaultMessage={'Minimum 8 characters'}
              />
            </div>
          </div>

          <div className="form-group">
            <div className="label-wrapper">
              <label />
            </div>
            <div className="button-wrapper">
              {isChangingPassword && <div className="loading small"></div>}
              {!isChangingPassword && (
                <div>
                  <button
                    type="submit"
                    className={`submit button btn-primary-lite ${
                      this.shouldAllowSubmit() ? 'active' : 'disabled'
                    }`}
                    onClick={this.changePasswordBound}
                  >
                    {save}
                  </button>
                  <div className={statusTextClass}>
                    {passwordChangeSuccess && (
                      <FormattedMessage
                        id={'Account.YouUpdatedYourPassword'}
                        defaultMessage={'You updated your password.'}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="form-group">
            <div className="label-wrapper">
              <label>{photo}</label>
            </div>
            <div className="image-upload-wrapper">
              <div className="image-wrapper">
                {this.state.files.length > 0 && (
                  <div className="selected-file">
                    <div>
                      <img src={this.state.files[0].preview} />
                      <div className="image-info">
                        <div>{this.state.files[0].name}</div>
                        <div>{this.state.files[0].size} bytes</div>
                      </div>
                    </div>
                  </div>
                )}
                <Dropzone
                  onDrop={this.onImageSelectBound}
                  className="image-selection-helper"
                  activeClassName="image-selection-helper active"
                >
                  <div>
                    Drag an image here, or <span>choose a file</span> from your
                    computer.
                  </div>
                </Dropzone>
              </div>
            </div>
          </div>
          <div className="form-group">
            <div className="label-wrapper">
              <label>&nbsp;</label>
            </div>
            <div className="instructions">
              <FormattedMessage
                id="ForBestViewing"
                defaultMessage="For best viewing, please use a square image (png format) no larger than 200x200 pixels and file size no larger than 500 kb"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="label-wrapper">
              <label />
            </div>
            <div className="button-wrapper">
              {this.props.isUploadingPhoto && <div className="loading"></div>}
              {!this.props.isUploadingPhoto && (
                <div>
                  <button
                    type="submit"
                    className={`button upload btn-primary-lite ${
                      this.state.files.length > 0 ? 'active' : 'disabled'
                    }`}
                    disabled={this.state.files.length === 0}
                    onClick={this.uploadPhotoBound}
                  >
                    {save}
                  </button>
                  {this.state.files.length > 0 && (
                    <div
                      className="button cancel"
                      onClick={this.resetFilesBound}
                    >
                      {cancel}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </form>
      </div>
    )
  }

  changePassword(e) {
    e.preventDefault()
    this.shouldAllowSubmit()
      ? this.props.dispatch(
          changePassword(this.state.currentPassword, this.state.newPassword)
        )
      : null
  }

  handleCurrentPasswordChange(e) {
    this.setState({ currentPassword: e.target.value })
  }

  handleNewPasswordChange(e) {
    this.setState({ newPassword: e.target.value })
  }

  onImageSelect(files) {
    this.setState({
      files: files
    })
  }

  resetFiles() {
    this.setState({ files: [] })
  }

  shouldAllowSubmit() {
    return (
      validatePassword(this.state.newPassword) &&
      this.state.currentPassword.length > 0
    )
  }

  async uploadPhoto(e) {
    e.preventDefault()
    this.props
      .dispatch(updateAccount(this.state.files[0], undefined))
      .then(this.resetFilesBound)
  }

  toggleShowPasswords() {
    this.setState(state => ({ showPasswords: !state.showPasswords }))
  }
}

Account.propTypes = {
  user: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  isChangingPassword: PropTypes.bool.isRequired,
  isUploadingPhoto: PropTypes.bool.isRequired,
  passwordChangeSuccess: PropTypes.bool.isRequired,
  passwordChangeFailure: PropTypes.bool.isRequired
}

export const mapStateToProps = state => ({
  user: state.user.user,
  isChangingPassword: state.account.isChangingPassword,
  isUploadingPhoto: state.user.isUpdatingAccount,
  passwordChangeSuccess: state.account.passwordChangeSuccess,
  passwordChangeFailure: state.account.passwordChangeFailure
})

export default connect(mapStateToProps)(Account)
export { Account as AccountDisconnected } // pure component - used in tests



// WEBPACK FOOTER //
// ./src/containers/Account.js